import { FilePptFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { DocumentIcons } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconFilePptFilled: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <FilePptFilled {...props} style={{ ...props.style, color: DocumentIcons.PowerPoint }} />;
};
